export function makeId(length: number) {
    let result = '';
    let characters = 'ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;

    for (let i=0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result
}

export function makeIdWithCharType(length:any, charType:any='AlphaNumeric') {
    var result           = '';
    var characters
    if(charType == 'Alphabetic') {
      characters       = 'ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz';
    }else if (charType == 'Numeric'){
      characters       = '0123456789';
    } else {
      characters       = 'ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz0123456789';
    }
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }